import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpEventType } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { FileUploadEventsService } from '../services/file-upload-events.service';

@Injectable()
export class HttpProgressInterceptor implements HttpInterceptor {
  private readonly uploadEvents = inject(FileUploadEventsService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.reportProgress) {
      const fileName = req.headers.get('x-file-name') || 'unknown';
      return next.handle(req).pipe(
        tap({
          next: (event: HttpEvent<unknown>) => {
            if (event.type === HttpEventType.DownloadProgress || event.type === HttpEventType.UploadProgress) {
              const progress = event.total ? Math.round((event.loaded / event.total) * 100) : 0;
              this.uploadEvents.uploadProgress(fileName, progress);
            } else if (event.type === HttpEventType.Response) {
              this.uploadEvents.uploadComplete(fileName);
            }
          },
          error: (error) => {
            this.uploadEvents.uploadFailed(fileName, error?.message || 'Upload failed');
          }
        })
      );
    }
    return next.handle(req);
  }
}
